<script lang="ts">
	//Stores
	import { _deepClone } from 'src/helpers/utilities';
	//Types
	import type { ISceneObj } from 'src/types/SceneType';
	//Helpers
	import { scene_object_prototype } from 'src/components/Scenes/SceneWizard/scene_object';
	//Components
	import SceneWizard from 'src/components/Scenes/SceneWizard/SceneWizard.svelte';

	export let showModal: boolean;
	export let routeParams: {
		type: string;
		id: string;
	};

	let scene_id;
	let scene_object: ISceneObj = _deepClone(scene_object_prototype) as ISceneObj;

	if (routeParams?.type === 'room') {
		scene_object._meta.room = +routeParams?.id;
	}
</script>

<SceneWizard bind:id={scene_id} bind:showAddEditModal={showModal} on:close {scene_object} />
